export default "__VITE_ASSET__DYrAtREf__"